import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'spark-core-dx/components';
import { DeployDomainContextProvider } from './DeployDomainProvider';

//Loads screens/items dynamically.
//No custom, always 1 to 1.

const DeployDomain = () => {
    return (
        <DeployDomainContextProvider>
            <Layout>
                <Outlet />
            </Layout>
        </DeployDomainContextProvider>
    );
};

export default DeployDomain;